module.exports = __webpack_public_path__ + "assets/aa8094069fb5dd3fa4e7600f59fecfd7.jpg";